import fp from "lodash/fp";
import { combineReducers } from "redux";

import { address } from "./address/address.reducer";
import { business } from "./business/business.reducer";
import { creditHistory } from "./creditHistory/creditHistory.reducer";
import { generalInfo } from "./generalInfo/generalInfo.reducer";
import { owner } from "./owner/owner.reducer";
import { preApp } from "./preApplication/preApp.reducer";
import { reducer as form } from "redux-form";
import { servicePage } from "./servicePage/servicePage.reducer";
import { ui } from "./ui/ui.reducer";

export * from "./address/address.actions";
export * from "./business/business.actions";
export * from "./creditHistory/creditHistory.actions";
export * from "./generalInfo/generalInfo.actions";
export * from "./generalInfo/generalInfo.actions";
export * from "./owner/owner.actions";
export * from "./preApplication/preApp.actions";
export * from "./servicePage/servicePage.actions";
export * from "./ui/ui.actions";

export * from "./address/address.constants";
export * from "./business/business.constants";
export * from "./creditHistory/creditHistory.constants";
export * from "./generalInfo/generalInfo.constants";
export * from "./owner/owner.constants";
export * from "./preApplication/preApp.constants";
export * from "./servicePage/servicePage.constants";
export * from "./ui/ui.constants";

const sortObjByKeys = fp.flow(fp.toPairs, fp.sortBy(0), fp.fromPairs);

const rootReducer = combineReducers(
	sortObjByKeys({
		address,
		business,
		creditHistory,
		form,
		generalInfo,
		owner,
		preApp,
		servicePage,
		ui,
	}),
);

export default rootReducer;
